import { Stack } from '@mui/material';

import { EditableRegion } from '@/components/blockEditor/EditableRegion/EditableRegion';
import { Card } from '@/components/layout/Card/Card';

import { VERTICAL_SPACING } from '../../components/EducationalSlide.components';

export function PhilanthropicPlanning() {
  return (
    <Stack spacing={VERTICAL_SPACING}>
      {/* Introduction Card */}
      <Card variant="filled" sx={{ p: 2 }}>
        <Stack spacing={2}>
          <EditableRegion regionId="description" />
        </Stack>
      </Card>

      <EditableRegion regionId="vehicles" />
    </Stack>
  );
}
